module.exports = __webpack_public_path__ + "img/Cross.461b87fe.svg";